import { useCallback } from 'react';

export const useNumberFormat = () => {
	const formatNumber = useCallback((num: number | string): string => {
		const numStr = typeof num === 'string' ? num : num.toString();
		return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	}, []);

	const parseFormattedNumber = useCallback((str: string): string => {
		return str.replace(/\s/g, '');
	}, []);

	const filterNumericOnly = useCallback((str: string): string => {
		return str.replace(/\D/g, '');
	}, []);

	return {
		formatNumber,
		parseFormattedNumber,
		filterNumericOnly,
	};
};
